const ItemType = Object.freeze({
    BUNDLE: 'Bundle',
    DELIVERY_METHOD: 'Delivery Method',
    GENERIC: 'Generic',
    GIFT_VOUCHER: 'Gift Voucher',
    ITEM_OPTION: 'Item Option',
    MEMBERSHIP_PLAN: 'Membership Plan',
    PRODUCT: 'Product',
    PRODUCT_FOOD: 'Food', // A special type used only on EPOS
    PRODUCT_KITCHEN: 'Kitchen Item', // A special type used only on EPOS for products shown on the kitchen screen
    SURCHARGE: 'Surcharge',
    TICKET: 'Ticket',
});

/**
 * Can be used as a type e.g.
 * param {ItemTypeValue} itemType.
 *
 * @typedef {'Bundle'
 *     |'Delivery Method'
 *     |'Generic'
 *     |'Gift Voucher'
 *     |'Item Option'
 *     |'Membership Plan'
 *     |'Product'
 *     |'Food'
 *     |'Surcharge'
 *     |'Ticket'} ItemTypeValue
 */

module.exports = ItemType;
